var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"terms"},[_c('div',{staticClass:"container"},[_c('img',{staticClass:"logo",attrs:{"src":"/images/logo-white.svg","alt":"wifeed logo"}}),_c('h1',{ref:"termsTitle",staticClass:"terms-title"}),_c('div',{ref:"termsContent",staticClass:"terms-content"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }